module.exports = __webpack_public_path__ + "media/images/plus-8ff6ae43cb1048f87d6793b2dfc78156.svg";